






















































































import { Component, Vue } from 'vue-property-decorator';
import { State, Action, Mutation } from 'vuex-class';
import { ITransactionInput } from '../models/transaction';
import NumberPad from '../components/NumberPad.vue';
import CategoryList from '../components/CategoryList.vue';
import DatePicker from '../components/DatePicker.vue';
import toFixedAmount from '../filters/toFixedAmount';
import { Decimal } from 'decimal.js';
@Component({
  components: {
    NumberPad,
    CategoryList,
    DatePicker,
  },
  filters: {
    toFixed: toFixedAmount,
  },
})
export default class AddTransaction extends Vue {

  get notes() {
    return this.draftTransaction.notes;
  }

  set notes(value) {
    this.$store.commit('updateDraftTransaction', {
      ...this.draftTransaction,
      notes: value,
    });
  }
  @State private draftTransaction!: ITransactionInput;
  @Mutation private updateDraftTransaction!: (
    transactionInput: ITransactionInput,
  ) => void;

  private isCreate = true;

  public async mounted() {
    this.$store.commit('setBottomNav', false);
    this.$store.commit('setShowTopBar', false);

    if (this.$route.path !== '/transactions/add') {
      this.isCreate = false;

      const { id } = this.$route.params;
      await this.$store.dispatch('loadTransactionIntoDraft', id);
    }
  }

  public beforeDestroy() {
    this.$store.commit('setBottomNav', true);
    this.$store.commit('setShowTopBar', true);
  }

  public onCancel() {
    this.$router.push('/');
  }

  public async onSave() {

    let actionName = 'addTransactionAsync';
    if (!this.isCreate) {
      actionName = 'updateTransactionAsync';
    }

    await this.$store.dispatch(actionName, this.draftTransaction);
    this.$store.commit('resetDraftTransaction');
    this.$router.push('/');
  }

  public onClear() {
    this.updateAmount(0);
  }

  public onDigit(digit: number) {
    let currentValue = new Decimal(this.draftTransaction.amount);
    currentValue = currentValue.mul(10).add(new Decimal(digit).mul(0.01));
    this.updateAmount(currentValue.toNumber());
  }

  public onBack() {
    let currentValue = new Decimal(this.draftTransaction.amount);
    currentValue = currentValue
      .mul(100)
      .floor()
      .dividedBy(10)
      .floor()
      .dividedBy(100);
    this.updateAmount(currentValue.toNumber());
  }

  public updateCategoryId(id: string) {
    this.$store.commit('updateDraftTransaction', {
      ...this.draftTransaction,
      categoryId: id,
    });
  }

  private updateAmount(amount: number) {
    this.$store.commit('updateDraftTransaction', {
      ...this.draftTransaction,
      amount,
    });
  }
}
